import { AppBar, Box, Paper, Toolbar, Typography } from '@mui/material';
import React from 'react';
import Text from '../../shared/Text';
import MimecastLogo from './logo-icon/MimecastLogo';

type Props = {
  noPadding?: boolean;
};

const CommonStaticLayout: React.FC<Props> = ({ children, noPadding }) => (
  <Box>
    <AppBar component="nav" position="static" sx={{ backgroundColor: '#1565C0', height: '48px' }}>
      <Toolbar variant="dense" disableGutters sx={{ px: 3 }}>
        <Box display="flex" gap={1.5} alignItems="center">
          <MimecastLogo />
          <Typography variant="h3" component="div" sx={{ color: '#ffffff', letterSpacing: 0 }}>
            {Text.get('incydr_header')}
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
    <Box display="flex" justifyContent="center" alignItems="center" height="calc(100vh - 272px)">
      <Paper
        elevation={1}
        sx={{
          width: '640px',
          borderRadius: '4px',
          padding: noPadding ? 0 : '40px',
        }}
      >
        {children}
      </Paper>
    </Box>
  </Box>
);

export default CommonStaticLayout;
